import { UIComponentConfiguration } from 'communication/types/uiConfiguration/UIConfiguration';
import { WidgetId } from 'widgets/WidgetId';
import omit from 'lodash/omit';

export function extractWidgetConfigFromComponents(components: {
    [key: string]: UIComponentConfiguration;
}): Array<{ id: WidgetId; config: Partial<unknown> }> {
    return Object.keys(components ?? {}).map((widgetKey) => {
        const config = components[widgetKey];
        const widgetType = config.type;
        return { id: { widgetKey, widgetType }, config: omit(config, 'type') };
    });
}
